'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

var _lineConstants = require('../../../common/lines/lineConstants');

var _dndConstants = require('../../utils/dnd/dndConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Constants


var getIsOtherEdgeAlreadyConnected = function getIsOtherEdgeAlreadyConnected(props, monitor) {
    var element = props.element;


    var elementId = element.get('id');
    var draggedEdge = monitor.getItem().edge;
    var lineElement = monitor.getItem().element;

    var oppositeEdge = draggedEdge === _lineConstants.LINE_EDGE.start ? _lineConstants.LINE_EDGE.end : _lineConstants.LINE_EDGE.start;
    return lineElement.getIn(['content', oppositeEdge, 'elementId']) === elementId;
};

var getIsAlreadyConnected = function getIsAlreadyConnected(props, monitor) {
    var element = props.element;

    var elementId = element.get('id');
    var lineElement = monitor.getItem().element;
    return lineElement.getIn(['content', 'start', 'elementId']) === elementId || lineElement.getIn(['content', 'end', 'elementId']) === elementId;
};

var elementLineEdgeDropTargetSpec = {
    drop: function drop(props, monitor) {
        var element = props.element;


        if (monitor.didDrop()) return;

        var elementId = element.get('id');

        // If already connected prevent drop
        var isAlreadyConnected = getIsAlreadyConnected(props, monitor);
        if (isAlreadyConnected) return;

        var offsetDiff = monitor.getDifferenceFromInitialOffset() || _dndConstants.NO_DRAG_OFFSET;
        return { offsetDiff: offsetDiff, snapped: true, elementId: elementId };
    },
    hover: function hover(props, monitor, component) {
        // If other edge already connected prevent hover style
        var isOtherEdgeAlreadyConnected = getIsOtherEdgeAlreadyConnected(props, monitor);
        component.setAlreadyConnected(isOtherEdgeAlreadyConnected);
    },
    canDrop: function canDrop(props) {
        return !props.isLocked;
    }
};

var elementLineEdgeDropCollect = function elementLineEdgeDropCollect(connector, monitor) {
    return {
        connectLineEdgeDropTarget: connector.dropTarget(),
        isLineEdgeHovered: monitor.isOver({ shallow: true })
    };
};

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var elementLineEdgeDropTarget = (_dec = (0, _reactDnd.DropTarget)(_lineConstants.LINE_EDGE_DND_TYPE, elementLineEdgeDropTargetSpec, elementLineEdgeDropCollect), _dec(_class = function (_React$Component) {
        _inherits(elementLineEdgeDropTarget, _React$Component);

        function elementLineEdgeDropTarget(props) {
            _classCallCheck(this, elementLineEdgeDropTarget);

            var _this = _possibleConstructorReturn(this, (elementLineEdgeDropTarget.__proto__ || Object.getPrototypeOf(elementLineEdgeDropTarget)).call(this, props));

            _this.setAlreadyConnected = function (isAlreadyConnected) {
                if (_this.state.isAlreadyConnected === isAlreadyConnected) return;
                _this.setState({ isAlreadyConnected: isAlreadyConnected });
            };

            _this.state = { isAlreadyConnected: false };
            return _this;
        }

        _createClass(elementLineEdgeDropTarget, [{
            key: 'render',
            value: function render() {
                var _props = this.props,
                    isLineEdgeHovered = _props.isLineEdgeHovered,
                    props = _objectWithoutProperties(_props, ['isLineEdgeHovered']);

                var isAlreadyConnected = this.state.isAlreadyConnected;

                var showIsHovered = !props.isLocked && isLineEdgeHovered && !isAlreadyConnected;

                return _react2.default.createElement(DecoratedComponent, _extends({ isLineEdgeHovered: showIsHovered }, props));
            }
        }]);

        return elementLineEdgeDropTarget;
    }(_react2.default.Component)) || _class);


    elementLineEdgeDropTarget.propTypes = {
        element: _propTypes2.default.object.isRequired,
        getIsAlreadyConnected: _propTypes2.default.func,
        isLineEdgeHovered: _propTypes2.default.bool
    };

    return elementLineEdgeDropTarget;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/elementLineEdgeDropTarget.js
// module id = 200
// module chunks = 0